import React, { useEffect, useCallback } from 'react';
import { IconDownload, IconX } from '@tabler/icons-react';
import { downloadFileByUrl } from '../../lib/utils';

interface Props {
  src: string;
  getDownloadUrl: () => Promise<string>;
  filename: string;
  onClose: () => void;
}

const PdfLightbox: React.FC<Props> = ({ src, getDownloadUrl, filename, onClose }) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopImmediatePropagation();
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown, { capture: true });
    return () => window.removeEventListener('keydown', onKeyDown, { capture: true });
  }, [onClose]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleDownload = useCallback(() => {
    void getDownloadUrl().then(url => downloadFileByUrl(url, filename));
  }, [getDownloadUrl, filename]);

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  return (
    <div className="lightbox-overlay pdf-lightbox-overlay" onClick={handleOverlayClick}>
      <button
        className="lightbox-close"
        type="button"
        onClick={onClose}
        onMouseDown={stopPropagation}
        aria-label="Закрыть"
      >
        <IconX size={20} stroke={2} />
      </button>

      <div className="pdf-lightbox-frame" onClick={stopPropagation} onMouseDown={stopPropagation}>
        <iframe
          className="pdf-lightbox-iframe"
          src={src}
          title={filename}
        />
      </div>

      <div className="lightbox-toolbar" onClick={stopPropagation} onMouseDown={stopPropagation}>
        <span className="lb-filename">{filename}</span>
        <div className="lb-sep" />
        <button className="lb-btn" type="button" onClick={handleDownload} title="Скачать">
          <IconDownload size={18} stroke={2} />
        </button>
      </div>
    </div>
  );
};

export { PdfLightbox };
